import React from "react";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  defaultStyle?: boolean;
}
const defaultStyles = "md:w-full md:bg-white md:rounded-2xl md:shadow-lg md:p-6";

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, className = "", defaultStyle = true, ...props }, ref) => {
    const appliedClassName = defaultStyle
      ? `${defaultStyles} ${className}`
      : className;
    return (
      <div ref={ref} className={appliedClassName} {...props}>
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";

export { Card };
